module.exports = __webpack_public_path__ + "static/media/SOUND_ON_White.0cf4e559.svg";